export default {
  category: Object.freeze({
    USUAL: 'usual', SUPPORT: 'support', INTEGRATOR: 'integrator', USUAL_LABEL: 'Сотрудники',
    SUPPORT_LABEL: 'Техническая поддержка', INTEGRATOR_LABEL: 'Клиники',
  }),
  deductionAmountType: Object.freeze({
    PERCENT: 'percent', AMOUNT: 'amount', PERCENT_LABEL: 'Процент, %', AMOUNT_LABEL: 'Сумма, руб.',
  }),
}
